// GoogleImportButton.jsx - IMPROVED VERSION
import { useState } from 'react';
import axios from 'axios';

function GoogleImportButton({ onReviewsImported, businessId }) {  // Added businessId prop
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [googleUrl, setGoogleUrl] = useState('');  // Changed from placeId to URL
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  // Function to extract Place ID from Google Maps URL
  const extractPlaceIdFromUrl = (url) => {
    try {
      // Handle different Google Maps URL formats
      const match = url.match(/place\/([^\/]+)\/?/);
      return match ? match[1] : null;
    } catch (error) {
      return null;
    }
  };

  const handleImport = async () => {
    if (!googleUrl.trim()) return;

    // Basic validation: must look like a Google Maps URL
    if (!googleUrl.includes('google.com/maps') && !googleUrl.includes('maps.google.com')) {
      setError('Please paste a URL from Google Maps (maps.google.com).');
      return;
    }

    setIsLoading(true);
    setError('');

    try {
      const response = await axios.post('/api/import-google-reviews', {
        google_maps_url: googleUrl.trim(),
      }, { withCredentials: true });

      if (response.data.success) {
        if (typeof onReviewsImported === 'function') {
          // Parent handles refresh — don't update local state (parent may unmount us)
          onReviewsImported();
          return;
        }
        // No callback — just reload the page so reviews appear
        window.location.reload();
        return;
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to import reviews');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      {/* Large Google Icon Button - THIS PART IS GOOD */}
      <div 
        className="flex flex-col items-center justify-center p-8 border-2 border-dashed border-gray-300 rounded-lg cursor-pointer hover:border-blue-400 transition-colors"
        onClick={() => setIsModalOpen(true)}
      >
        <svg
        xmlns="http://www.w3.org/2000/svg"
        width="64"
        height="64"
        viewBox="0 0 48 48"  // Keep this viewBox
        className="mb-4"
        >
        <path
            fill="#4285F4"
            d="M24 9.5c3.34 0 5.63 1.44 6.93 2.65l5.08-4.91C32.67 4.02 28.74 2 24 2 14.91 2 7.54 7.88 4.64 15.35l5.89 4.57C12.12 13.12 17.56 9.5 24 9.5z"
        />
        <path
            fill="#34A853"
            d="M46.5 24c0-1.53-.14-2.99-.4-4.4H24v8.33h12.7c-.55 3.02-2.19 5.58-4.7 7.31l7.38 5.71C43.98 36.9 46.5 30.97 46.5 24z"
        />
        <path
            fill="#FBBC05"
            d="M10.53 28.74a14.4 14.4 0 0 1 0-9.47l-5.89-4.57a23.953 23.953 0 0 0 0 18.61l5.89-4.57z"
        />
        <path
            fill="#EA4335"
            d="M24 46c6.48 0 11.91-2.15 15.88-5.86l-7.38-5.71c-2.04 1.37-4.65 2.19-8.5 2.19-6.44 0-11.88-3.62-14.46-8.77l-5.89 4.57C7.54 40.12 14.91 46 24 46z"
        />
        </svg>

        <p className="text-sm text-gray-500 text-center mt-2">
          Click here to import your 5 most recent Google Business reviews
        </p>
      </div>

      {/* Import Modal - UPDATED FOR URL INPUT */}
      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 w-96">
            <h3 className="text-lg text-[#00aef7] font-bold mb-4">Import Google Reviews</h3>
            
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Google Maps Business URL
              </label>
              <input
                type="text"
                value={googleUrl}
                onChange={(e) => setGoogleUrl(e.target.value)}
                placeholder="Paste your Google Business Profile URL"
                className="w-full p-2 border border-gray-300 rounded focus:ring-blue-500 focus:border-blue-500"
              />
              <p className="text-xs text-gray-500 mt-1">
                Go to maps.google.com, search for your business, click on it and copy the entire web address and paste it here. You may need to claim your business first.
              </p>
              <p className="text-xs text-gray-500 mt-1">
                Google only allows the 5 most recent reviews to be imported. You can import new Google reviews every 30 days.
              </p>
            </div>

            {error && (
              <p className="text-red-500 text-sm mb-4">{error}</p>
            )}

            <div className="flex justify-end space-x-2">
              <button
                onClick={() => {
                  setIsModalOpen(false);
                  setError('');
                }}
                className="px-4 py-2 text-gray-600 hover:text-gray-800"
                disabled={isLoading}
              >
                Cancel
              </button>
              <button
                onClick={handleImport}
                disabled={isLoading || !googleUrl.trim()}
                className="px-4 py-2 bg-[#00aef7] text-white rounded hover:bg-blue-300 disabled:opacity-50"
              >
                {isLoading ? 'Importing...' : 'Import Reviews'}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default GoogleImportButton;